export const AUTH_PROVIDERS_LIST_SCREEN = 'auth_providers_list_screen';
export const AUTH_STACK = 'auth_stack';
